export default __webpack_public_path__ + "static/media/equipmentCategory.5cd1bc8c.jpg";